export const POTENTIAL_PENDING_STAGES = ['Received', 'Proposed'];
export const ORDER_PENDING_STAGES = ['Accepted'];
export const CANCELLED_STATUSES = ['Cancelled', 'Pro Cancellation', 'Not Honored', 'No Pros'];
export const BOOKING_TYPES = {
  POTENTIAL: 'potential',
  ORDER: 'order',
};

export const REFUSAL_MOTIVATIONS = {
  RESCHEDULED: 'Rescheduled',
};
